import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Paper,
  Grid,
  Button,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  getDrivers,
  addDriver,
  deleteDriver,
  getBrokers,
  addBroker,
  deleteBroker
} from '../api';

import { useCarrier } from '../context/CarrierContext';

const ControlPanel = () => {
  const { carrierId } = useCarrier(); // ✅ REQUIRED

  const [showDrivers, setShowDrivers] = useState(false);
  const [showBrokers, setShowBrokers] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [newDriver, setNewDriver] = useState('');
  const [newBroker, setNewBroker] = useState('');

  useEffect(() => {
    if (showDrivers) fetchDrivers();
    if (showBrokers) fetchBrokers();
  }, [showDrivers, showBrokers, carrierId]); // ✅ refetch on carrier change

  const fetchDrivers = async () => {
    const data = await getDrivers(carrierId); // ✅ FIXED
    setDrivers(data);
  };

  const fetchBrokers = async () => {
    const data = await getBrokers();
    setBrokers(data);
  };

  const handleAddDriver = async () => {
    if (!newDriver.trim()) return;
    await addDriver(newDriver, carrierId); // ✅ FIXED
    setNewDriver('');
    fetchDrivers();
  };

  const handleDeleteDriver = async (id) => {
    await deleteDriver(id, carrierId); // ✅ FIXED
    fetchDrivers();
  };

  const handleAddBroker = async () => {
    if (!newBroker.trim()) return;
    await addBroker(newBroker);
    setNewBroker('');
    fetchBrokers();
  };

  const handleDeleteBroker = async (id) => {
    await deleteBroker(id);
    fetchBrokers();
  };

  return (
    <Container>
      <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
        <Typography variant="h5" gutterBottom>
          Control Panel
        </Typography>

        {/* DRIVERS */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h6">Manage Drivers</Typography>
            <Button
              variant="outlined"
              fullWidth
              sx={{ mt: 1 }}
              onClick={() => setShowDrivers(!showDrivers)}
            >
              {showDrivers ? 'Hide Drivers' : 'View/Edit Drivers'}
            </Button>

            {showDrivers && (
              <>
                <List dense>
                  {drivers.map(driver => (
                    <ListItem
                      key={driver.id}
                      secondaryAction={
                        <IconButton onClick={() => handleDeleteDriver(driver.id)}>
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText primary={driver.name} />
                    </ListItem>
                  ))}
                </List>

                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <TextField
                      fullWidth
                      label="New Driver"
                      value={newDriver}
                      onChange={e => setNewDriver(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={handleAddDriver}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>

          {/* BROKERS */}
          <Grid item xs={12} sm={6}>
            <Typography variant="h6">Manage Brokers</Typography>
            <Button
              variant="outlined"
              fullWidth
              sx={{ mt: 1 }}
              onClick={() => setShowBrokers(!showBrokers)}
            >
              {showBrokers ? 'Hide Brokers' : 'View/Edit Brokers'}
            </Button>

            {showBrokers && (
              <>
                <List dense>
                  {brokers.map(broker => (
                    <ListItem
                      key={broker.id}
                      secondaryAction={
                        <IconButton onClick={() => handleDeleteBroker(broker.id)}>
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText primary={broker.name} />
                    </ListItem>
                  ))}
                </List>

                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <TextField
                      fullWidth
                      label="New Broker"
                      value={newBroker}
                      onChange={e => setNewBroker(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={handleAddBroker}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ControlPanel;
